import TapNovelRestApi from '../../../../../data/data_stores/net/TapNovelRestApi';

export default TapNovelRestApi;
